module.exports = __webpack_public_path__ + "static/img/messenger.0df06f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/messenger.png
// module id = y/gN
// module chunks = 48